import { render, staticRenderFns } from "./Page500.vue?vue&type=template&id=12c0336e&scoped=true&"
import script from "./Page500.vue?vue&type=script&lang=js&"
export * from "./Page500.vue?vue&type=script&lang=js&"
import style0 from "./Page500.vue?vue&type=style&index=0&id=12c0336e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0336e",
  null
  
)

export default component.exports